/**
 * FAQs
 */


if ($('.c-faqs').length) {
    $('.c-faqs__button').on('click', function () {
        if ($(this).attr('aria-expanded') == 'false') {
            $(this).attr('aria-expanded', 'true').addClass('is-active');
            $(this).closest('.c-faqs__question').next('.c-faqs__answer').slideDown();
        } else {
            $(this).attr('aria-expanded', 'false').removeClass('is-active');
            $(this).closest('.c-faqs__question').next('.c-faqs__answer').slideUp();
        }
    })
}